<template>
    <div class="c-client-nav-buttons">
        <button :class="{hidden : prevStep === null}" :disabled="buttonsDisabled"  @click.prevent="emitPrevStep">
            {{$t('generic.prev')}}
        </button>
        <button :class="{hidden : nextStep === null}" :disabled="buttonsDisabled"  @click.prevent="emitNextStep" class="next">
            {{$t('generic.next')}}
        </button>
    </div>
</template>

<script>
export default {
    name:"ClientNavButtons",
    props: {
        prevStep: {type: String, default:null},
        nextStep: {type: String, default:null},
        buttonsDisabled: {type: Boolean, default:false}
    },

    methods: {
        emitPrevStep() {
            if (this.buttonsDisabled) return;

            this.$emit("prevStep", this.prevStep);
        },

        emitNextStep() {
            if (this.buttonsDisabled) return;

            this.$emit("showStep", this.nextStep);
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-client-nav-buttons {
        width: 10vw;
        bottom: 2%;
        text-align: center;
        left: 50%;
        margin-left: -5vw;
        display: flex;
        justify-content: space-evenly;
        height : 5vh;

        button {
            @extend .reset-btn;
            font-size: 1.65em;
            margin : 0 .8em;
            position: relative;
            padding : 0 1rem;

            &.next {
                font-weight: bold;

                &:after {
                    content : ' ';
                    width : 60%;
                    height : .2rem;
                    background : $color-blue;
                    display: block;
                    left: 12.5%;
                    position: absolute;
                    top: 1.9em;
                }
            }

            &.hidden {
                visibility : hidden;
            }

            @for $i from 1 through 2 {
                &:nth-child(#{$i}) {
                    @include slideIntroAnimation(basicSlideIntro, 450ms, #{$i * 250ms});
                }
            }
        }
    }
</style>